"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHookedSources = void 0;
const memo_compare_hook_1 = require("../../../utils/memo-compare-hook");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const EMPTY_HOOKED_SOURCE = {};
function defaultHook() {
    return {};
}
function compare(prev, next) {
    let isLoading = [];
    if (next) {
        isLoading = Object.values(next).map(({ source }) => source.loading);
    }
    if (isLoading.includes(true)) {
        return true;
    }
    else {
        return false;
    }
}
function useHookedSources(hook) {
    // unfortunately I couldnt find better naming :(
    const useSources = hook !== null && hook !== void 0 ? hook : defaultHook;
    const hookedSources = useSources();
    const memoizedHookedSources = memo_compare_hook_1.useMemoCompare(hookedSources, compare);
    const refreshAllHookedSources = event_callback_hook_1.useEventCallback(async (data) => {
        const promises = [];
        Object.values(hookedSources).map(({ source, shouldLoad, modifyBeforeLoad }) => {
            source === null || source === void 0 ? void 0 : source.reset();
            if (shouldLoad(data)) {
                if (modifyBeforeLoad) {
                    modifyBeforeLoad(data);
                }
                promises.push(source === null || source === void 0 ? void 0 : source.loadMore());
            }
        });
        await Promise.all(promises);
    });
    const resetAllHookedSources = event_callback_hook_1.useEventCallback(() => {
        Object.values(hookedSources).map(({ source }) => {
            source === null || source === void 0 ? void 0 : source.reset();
        });
    });
    return {
        hookedSources: memoizedHookedSources !== null && memoizedHookedSources !== void 0 ? memoizedHookedSources : EMPTY_HOOKED_SOURCE,
        refreshAllHookedSources,
        resetAllHookedSources,
    };
}
exports.useHookedSources = useHookedSources;
//# sourceMappingURL=hooked-source-hook.js.map